import React, { ReactNode } from 'react';
import { map } from 'lodash';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';

export interface DataDetailListProps {
  rows: {
    label: ReactNode;
    value?: ReactNode;
    className?: string;
    labelClassName?: string;
    valueClassName?: string;
  }[];
  heading?: ReactNode;
  headingStyle?: React.CSSProperties;
}

export function DataDetailList({
  heading = undefined,
  rows,
  headingStyle = undefined,
}: DataDetailListProps) {
  return (
    <div>
      {heading && (
        <>
          <h6 className="pb-2" style={headingStyle}>
            {heading}
          </h6>
          <hr />
        </>
      )}
      <Table
        size="small"
        sx={{
          '& .MuiTableCell-root': {
            border: 0,
            backgroundColor: 'transparent',
            padding: '4px 0',
          },
        }}
      >
        <TableBody>
          {map(rows, (row, idx) => (
            <TableRow
              key={idx}
              className={row.className}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
              }}
            >
              <TableCell
                className={`fw-light small text-muted text-nowrap ${row?.labelClassName ?? ''}`}
                sx={{
                  fontWeight: 300,
                  fontSize: '0.875rem',
                  color: 'text.secondary',
                  whiteSpace: 'nowrap',
                  width: 'auto',
                }}
              >
                {row.label}:&nbsp;
              </TableCell>
              <TableCell className={row?.valueClassName ?? ''}>
                {row.value || '-'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
